import './footer.css';

function Footer(){
    return(
        <footer>
            <hr />
            <p>Direitos da ApexLoom

            </p>
        </footer>
    )
}

export default Footer;